import React, { useState } from "react";
import "../css/StaffAndResults.css";

const StaffAndResults = () => {
  const [activeShift, setActiveShift] = useState("morning");

  const morningStaff = [
    { slNo: 1, info: "Principal", details: "Mr. Caesar D'silva", type: "main" },
    { slNo: 2, info: "Total No. Of Teachers", details: "98", type: "main" },
    { slNo: "", info: "PGT", details: "13", type: "sub" },
    { slNo: "", info: "TGT", details: "36", type: "sub" },
    { slNo: "", info: "PRT", details: "49", type: "sub" },
    { slNo: 3, info: "Teachers Section Ratio", details: "1.5:1", type: "main" },
    {
      slNo: 4,
      info: "Details Of Special Educator",
      details: "Ms. Dipali Chauhan",
      type: "main",
    },
    {
      slNo: 5,
      info: "Details Of Counsellor And Wellness Teacher",
      details: "Ms. Divya Ramasubramanium",
      type: "main",
    },
  ];

  const afternoonStaff = [
    { slNo: 1, info: "Principal", details: "Mr. Caesar D'silva", type: "main" },
    { slNo: 2, info: "Total No. Of Teachers", details: "72", type: "main" },
    { slNo: "", info: "PGT", details: "10", type: "sub" },
    { slNo: "", info: "TGT", details: "28", type: "sub" },
    { slNo: "", info: "PRT", details: "34", type: "sub" },
    { slNo: 3, info: "Teachers Section Ratio", details: "1.4:1", type: "main" },
    {
      slNo: 4,
      info: "Details Of Special Educator",
      details: "Ms. Dipali Chauhan",
      type: "main",
    },
    {
      slNo: 5,
      info: "Details Of Counsellor And Wellness Teacher",
      details: "Ms. Divya Ramasubramanium",
      type: "main",
    },
  ];

  const currentStaffData =
    activeShift === "morning" ? morningStaff : afternoonStaff;

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-container">
        {}
        <h2 className="dashboard-main-title">
          Staff (Teaching) -{" "}
          {activeShift === "morning" ? "Morning Shift" : "Afternoon Shift"}
        </h2>

        {}
        <div className="tab-navigation">
          <button
            className={`tab-btn ${activeShift === "morning" ? "active" : ""}`}
            onClick={() => setActiveShift("morning")}
          >
            Staff (Teaching) - Morning Shift
          </button>
          <button
            className={`tab-btn ${activeShift === "afternoon" ? "active" : ""}`}
            onClick={() => setActiveShift("afternoon")}
          >
            Staff (Teaching) - Afternoon Shift
          </button>
        </div>

        {}
        <div className="table-responsive">
          <table className="dashboard-table border-black">
            <thead>
              <tr>
                <th style={{ width: "12%" }}>SL No.</th>
                <th style={{ width: "48%" }}>INFORMATION</th>
                <th style={{ width: "40%" }}>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              {currentStaffData.map((row, index) => (
                <tr key={index} className={row.type === "sub" ? "sub-row" : ""}>
                  <td className="text-center">{row.slNo}</td>
                  <td className={row.type === "sub" ? "padded-left" : ""}>
                    {row.info}
                  </td>
                  <td>{row.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {}
        <h3 className="section-subtitle">Result Class: X</h3>
        <div className="table-responsive">
          <table className="dashboard-table border-black">
            <thead>
              <tr>
                <th style={{ width: "12%" }}>SL No.</th>
                <th style={{ width: "12%" }}>YEAR</th>
                <th style={{ width: "28%" }}>NO. OF REGISTERED STUDENTS</th>
                <th style={{ width: "28%" }}>NO. OF STUDENTS PASSED</th>
                <th style={{ width: "20%" }}>PASS PERCENTAGE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">1</td>
                <td className="text-center">2023</td>
                <td className="text-center">98</td>
                <td className="text-center">98</td>
                <td className="text-center">100</td>
              </tr>
            </tbody>
          </table>
        </div>

        {}
        <h3 className="section-subtitle">Result Class: XII</h3>
        <div className="table-responsive">
          <table className="dashboard-table border-black">
            <thead>
              <tr>
                <th style={{ width: "12%" }}>SL No.</th>
                <th style={{ width: "12%" }}>YEAR</th>
                <th style={{ width: "28%" }}>NO. OF REGISTERED STUDENTS</th>
                <th style={{ width: "28%" }}>NO. OF STUDENTS PASSED</th>
                <th style={{ width: "20%" }}>PASS PERCENTAGE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">1</td>
                <td className="text-center">2023</td>
                <td className="text-center">43</td>
                <td className="text-center">43</td>
                <td className="text-center">100</td>
              </tr>
            </tbody>
          </table>
        </div>

        {}
        <h2 className="dashboard-main-title margin-top-lg">
          School Infrastructure
        </h2>
      </div>
    </div>
  );
};

export default StaffAndResults;
